import React from 'react'
import { IconContainer } from './TelegramIcon.styles'

export type TelegramIconProps = {
  width?: number
  height?: number
  backgroundColor?: string
  containerRadius?: number
}

const TelegramIcon: React.FC<TelegramIconProps> = ({
  width = 14,
  height = 11,
  backgroundColor = "#0C99E2",
  containerRadius = 24
}) => {
  return (
    <IconContainer $containerRadius={containerRadius} $backgroundColor={backgroundColor}>
      <svg width={width} height={height} viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.90811 10.282C4.51931 10.282 4.58541 10.1352 4.45131 9.76498L3.30811 6.00268L12.1081 0.781982" fill="#CBD9E8" />
        <path d="M4.90814 10.282C5.20814 10.282 5.34064 10.1448 5.50814 9.98196L7.10814 8.42616L5.11234 7.22266" fill="#AFC9DE" />
        <path d="M5.11213 7.223L9.94813 10.7959C10.5 11.1004 10.8982 10.9427 11.0357 10.2836L13.0042 1.0073C13.2057 0.199302 12.6962 -0.167298 12.1682 0.0724019L0.609234 4.5295C-0.179766 4.846 -0.175066 5.2862 0.465434 5.4823L3.43173 6.4082L10.299 2.0757C10.6232 1.8791 10.9208 1.9847 10.6766 2.2015" fill="white" />
      </svg>
    </IconContainer>
  )
}

export default TelegramIcon
